<template>
    <div class="administration-create-career-wrapper">
        <transition name="fade" mode="out-in">
            <div class="loading" v-if="isLoading" key="isLoadingAnimation">
                <img src="/static/img/admin/loading.svg" alt="Loading">
            </div>
            <div class="administration-create-career" v-else key="createNewsForm">
                <div class="administration-create-career-header">
                    <h2 v-if="isEditing">Редактирай позиция</h2>
                    <h2 v-else>Нова позиция</h2>
                    <div>
                    <a class="administration-career-close" @click="closeModal()">Отказ</a>
                    <button class="administration-career-form-submit" @click="postCareer()" :disabled="!isValid()">
                        <span v-if="!isEditing">Създай</span>
                        <span v-else>Запази</span>
                    </button>
                    </div>
                </div>
                <form class="administration-career-form">
                    <div class="career-input-wrapper">
                        <label>Име на позицията*</label>
                        <input class="career-input" type="text" v-model="careerObject.title">
                    </div>
                    <div class="career-dates-wrapper">
                        <div class="career-input-wrapper">
                            <label>Начална дата*</label>
                            <input class="career-input" type="text"
                            :value="careerObject.startDate | formatDate" placeholder="ДД-ММ-ГГГГ"
                            @change="createNewDateFromString($event, 'start')" @keyup="formatDate">
                        </div>
                        <div class="career-input-wrapper">
                            <label>Крайна дата*</label>
                            <input class="career-input" type="text"
                            :value="careerObject.endDate | formatDate" placeholder="ДД-ММ-ГГГГ"
                            @change="createNewDateFromString($event, 'end')" @keyup="formatDate">
                        </div>
                    </div>
                    <div class="career-content-wrapper" v-if="(this.isEditing && this.isCareerLoaded) || !this.isEditing">
                        <div class="career-input-wrapper">
                            <label>Основни функции и отговорности</label>
                            <div class="quill-editor-wrapper">
                            <app-quill-editor v-model="careerObject.responsibilities"></app-quill-editor>
                            </div>
                        </div>
                        <div class="career-input-wrapper">
                            <label>Изисквания към кандидатите</label>
                            <div class="quill-editor-wrapper">
                            <app-quill-editor v-model="careerObject.requirements"></app-quill-editor>
                            </div>
                        </div>
                        <div class="career-input-wrapper">
                            <label>Допълнителна информация</label>
                            <div class="quill-editor-wrapper">
                            <app-quill-editor v-model="careerObject.additional"></app-quill-editor>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </transition>
    </div>
</template>

<script>
import Editor from "../shared/Editor";
export default {
  components: {
    appQuillEditor: Editor
  },
  props: ["isEditing", "id"],
  data() {
    return {
      isLoading: false,
      isCareerLoaded: false,
      careerObject: {
        title: "",
        startDate: "",
        endDate: "",
        responsibilities: "",
        requirements: "",
        additional: ""
      }
    };
  },
  methods: {
    formatDate(event) {
      event.target.value = event.target.value
        .replace(/[^0-9-]/g, "")
        .substr(0, 10);
    },
    createNewDateFromString(event, which) {
      const t = event.target.value.match(/^(\d{2})\-(\d{2})\-(\d{4})$/);
      if (t !== null) {
        const d = +t[1];
        const m = +t[2];
        const y = +t[3];
        const date = new Date(y, m - 1, d);
        if (date.getFullYear() === y && date.getMonth() === m - 1) {
          if (which === "start") {
            this.careerObject.startDate = date;
            console.log(this.careerObject.startDate);
          } else if (which === "end") {
            this.careerObject.endDate = date;
            console.log(this.careerObject.endDate);
          }
        }
      }
    },
    isValid() {
      if (!this.careerObject.title) {
        return false;
      }
      if (!this.careerObject.startDate) {
        return false;
      }
      if (!this.careerObject.endDate) {
        return false;
      }
      return true;
    },
    findCareer() {
      this.$http
        .get(`${process.env.ROOT_API}/careers/${this.id}`)
        .then(response => {
          this.careerObject = response.data.career[0];
          this.isCareerLoaded = true;
        })
        .catch(error => {
          // handle error
          console.log(error);
        })
        .then(() => {
          // always executed
        });
    },
    postCareer() {
      if (this.isValid()) {
        this.isLoading = true;

        let requestUrl = `${process.env.ROOT_API}/careers`;
        if (this.isEditing) {
          requestUrl += `/update/${this.id}`;
        }

        this.$http
          .post(requestUrl, this.careerObject)
          .then(res => {
            this.isLoading = false;
            this.$eventHub.$emit("close-create-career");
          })
          .catch(err => {
            this.isLoading = false;
            console.log(err);
          });
      }
    },
    closeModal() {
      this.$eventHub.$emit("close-create-career");
    }
  },
  mounted() {
    if (this.isEditing) {
      this.findCareer();
    }
  }
};
</script>

<style scoped>
/* WRAPPER */
.administration-create-career-wrapper {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
}
/* MODAL */
.administration-create-career {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.05);
  height: 90vh;
  overflow: hidden;
  padding: 80px 30px 30px;
  position: relative;
  width: 1200px;
}
/* HEADER */
.administration-create-career-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  height: 80px;
  left: 0;
  padding: 0 30px;
  position: absolute;
  top: 0;
  width: 100%;
}
/* BUTTONS */
.administration-career-form-submit,
.administration-career-close {
  align-items: center;
  background-color: rgb(0, 156, 244);
  border: none;
  border-radius: 6px;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 16px;
  justify-content: center;
  margin-left: 6px;
  padding: 10px 20px;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.administration-career-form-submit > span {
  color: #fff;
}
.administration-career-form-submit:hover {
  background-color: rgba(0, 156, 244, 0.8);
}
.administration-career-form-submit-invalid {
  opacity: 0.2;
}
.administration-career-close {
  background-color: rgb(64, 64, 64);
}
.administration-career-close:hover {
  background-color: rgba(64, 64, 64, 0.9);
}
.administration-career-form-submit:disabled {
  cursor: default;
  background-color: #f3f3f3;
}
.administration-career-form-submit:disabled:hover {
  background-color: #f3f3f3;
}
/* FORM */
.administration-career-form {
  height: 100%;
  overflow: auto;
}
/* CONTENT */
.career-input-wrapper {
  position: relative;
  width: 100%;
}
.career-input {
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: #000;
  height: 40px;
  margin: 5px 0;
  padding: 0 15px;
  resize: none;
  width: 100%;
}
.career-dates-wrapper {
  display: flex;
  width: 100%;
}
.career-dates-wrapper .career-input-wrapper:first-child {
  margin-right: 20px;
}
/* QUILL EDITOR CONTENT */
.career-content-wrapper {
  background-color: #f5f5f5;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  padding: 20px;
  width: 100%;
}
/* QUILL */
.quill-editor-wrapper {
  background-color: #fff;
  border-radius: 6px;
  margin: 10px 0;
  overflow: hidden;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/administration/CareerModal.vue